import PDFMap from './PDFMap';

export default ({ titles, mapSrc, colour = 'print.primary.7' }) => {
    const { title, localName, subTitle, year, shortLink } = titles;
    const mapX = 40;
    const mapY = 210;
    const mapW = 420;
    const labelsY = mapY + mapW + 12;
    const shortLinkText = shortLink.replace(/https?:\/\//, '');
    const shortLinkHref = shortLink.startsWith('http') ? shortLink : `https://${shortLink}`;

    return {
        background: {
            position: 'page',
            colour
        },
        position: 'content',
        map: PDFMap({ mapSrc, colour, x: mapX, y: mapY, w: mapW }),
        title: {
            text: `${title}`,
            w: 400,
            font: { colour: 'print.light' },
        },
        localName: {
            mt: 10,
            w: 540,
            text: `${localName}`,
            font: { size: '4xl', weight: 'bold', colour: 'print.primary.1' },
        },
        subTitle: {
            text: `${subTitle}`,
            font: { size: 'xl', colour: 'print.primary.1' }
        },
        year: {
            text: `${year}`,
            position: 'content',
            baseline: 'alphabetic',
            font: { size: 'xl', colour: 'print.light' },
            y: labelsY
        },
        link: {
            text: `${shortLinkText}`,
            href: `${shortLinkHref}`,
            position: 'content',
            // border: { colour: '#ff0000' },
            x: mapX,
            w: mapW,
            align: 'right',
            baseline: 'alphabetic',
            font: { size: 'base', weight: 'bold', colour: 'print.light' },
            y: labelsY
        },
        titleFooter: {
            position: 'page',
            y: 710,
            h: 65,
            // border: { colour: '#ff0000' },
            left: {
                position: 'parent',
                src: 'AlbertaHealthServices_Logo.svg',
                w: 200,
                h: 90
            },
            right: {
                y: 20,
                img2: {
                    position: 'parent',
                    src: 'AHS-6236_HealthierTogether-color.svg',
                    // border: { colour: '#ffffff' },
                    x: 387,
                    w: 66,
                    y: 22,
                    h: 21
                },
                spacer: {
                    position: 'parent',
                    x: 471,
                    y: 15,
                    w: 1,
                    h: 41,
                    border: { colour: '#eeeeee' }
                },
                img3: {
                    position: 'parent',
                    src: 'AHS-5277_Community_Hub_FINAL_Logo-01.svg',
                    // border: { colour: '#ffffff' },
                    x: 487,
                    w: 104,
                    h: 21,
                    y: 22
                }
            }

        }
    };
};
